"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetRestaurant = void 0;
var react_query_1 = require("@tanstack/react-query");
var api_1 = require("../../../store/api");
var store_1 = require("../../../store/store");
var useClear_1 = require("../../../hooks/useClear");
var useGetRestaurant = function (_a) {
    var id = _a.id;
    (0, useClear_1.useClear)({ id: id });
    var searchParams = new URLSearchParams(location.search);
    var type = searchParams.get('type') || '';
    var tableQuery = searchParams.get('table') || '';
    return (0, react_query_1.useQuery)(['restaurant', id], function () { return (0, api_1.loadRestaurant)(id); }, {
        onSuccess: function (res) {
            if (tableQuery) {
                return;
            }
            var isDineIn = type === 'dinein';
            var isDelivery = type === 'delivery';
            var isPickUp = type === 'pickup';
            if (!isDineIn && !isDelivery && !isPickUp) {
                store_1.history.push({ pathname: "/store" });
            }
            if ((isDelivery && !res.has_delivery) || (isDineIn && !res.has_dine_in) || (isPickUp && !res.has_takeaway)) {
                store_1.history.push({ pathname: "/store" });
            }
        },
        onError: function () {
            store_1.history.push({ pathname: "/store" });
        },
    });
};
exports.useGetRestaurant = useGetRestaurant;
